/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React, { useState } from 'react';
import {
    shape, arrayOf, bool, func, string, object,
} from 'prop-types';
import ReactMarkdown from 'react-markdown';
import Dialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import { connect } from 'react-redux';
import Radio from '@material-ui/core/Radio';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { bindActionCreators } from 'redux';
import ResponsiveImage from '../../../../GraphqlCommonComponents/ResponsiveImage/ResponsiveImage';
import { getFeatureFlags } from '../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const useStyles = makeStyles((theme) => ({
    dialogTitle: {
        fontSize: '1.06em',
        textAlign: 'center',
        fontWeight: 'bold',
    },
    ContinueFlex: {
        color: '#fff',
        backgroundColor: theme.palette.colorSuccess,
        width: '202px',
        diplay: 'inherit',
        alignItems: 'inherit',
        marginLeft: '9px',
        [theme.breakpoints.down(600)]: {
            width: '160px',
        },
        [theme.breakpoints.down(480)]: {
            padding: '5px 15px',
            marginLeft: 0,
            width: '202px',
        },
    },
    GoBackFlex: {
        color: '#65388b',
        border: '1px solid rgba(101, 56, 139, 0.5)',
        lineHeight: '1.75',
        fontWeight: '500',
        borderRadius: '4px',
        textTransform: 'uppercase',
        width: '202px',
        marginRight: '9px',
        [theme.breakpoints.down(600)]: {
            width: '160px',
        },
        [theme.breakpoints.down(480)]: {
            padding: '5px 15px',
            margin: '0px 0px 15px 0px',
            width: '202px',
        },
    },
    MuiGridItem: {
        alignItems: 'center',
        justifyContent: 'center',
    },
    holidayBoxBorder: {
        outline: '1px solid darkgray',
        padding: '20px',
        marginBottom: '20px',
    },
    windowContent: {
        fontSize: '14px !important',
        fontWeight: '400',
    },
    flexMessage: {
        fontStyle: 'italic',
        fontSize: '1em',
        textAlign: 'center',
        color: 'rgba(0, 0, 0, 0.87)',
    },
    flexRadio: {
        color: '#65388b',
    },
    flexWraper: {
        padding: '20px',
    },
    buttonContainer: {
        justifyContent: 'center',
    },
    radioButtonColor: {
        color: theme.palette.cms?.primary || theme.palette.colorPrimary,
    },
    floristRadioButtonColor: {
        color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        '&$checked': {
            color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        },
    },
    checked: {},
    hideBtn: {
        display: 'none',
    },
    windowContentPadding: {
        paddingLeft: 0,
    },
    flexContent: {
        width: '100%',
    },
    mainImage: {
        textAlign: 'center',
    },
    holidayRedesignBox: {
        border: 'inherit',
        padding: 0,
    },
    image: {
        [theme.breakpoints.down(480)]: {
            width: '100%',
        },
    },
    label: {
        margin: 0,
    },
    flexOptionContainer: {
        width: '100%',
    },
}));

const FlexModal = ({
    flexData, isOpen, handleFlexClose, flexAddToCart, featureFlags, trackEventAction, flexTaggingData, dateFlexImage, brandId,
}) => {
    const classes = useStyles();
    const flexImage = dateFlexImage || {};
    const flexRedesignFlag = featureFlags['which-flex-redesign']?.variant !== 'CONTROL';
    // the following hook keeps track of which flex date is selected
    const [selectedDate, setDate] = useState(flexData.find((flexDate) => flexDate?.defaultOption === 'Y') || flexData?.[0]);
    const handleDateChange = (e) => {
        // The whole flex date object needs to be stored in state.
        setDate(flexData.find((flexDay) => flexDay.optionCode === e.target.value));
    };

    if (!flexRedesignFlag) {
        trackEventAction({
            eventCategory: 'Test Impression',
            eventAction: 'Flex Design Control',
        });
    }
    const trackFlexModalNavigationButton = (iscontinueBtn) => {
        const flexPrice =   iscontinueBtn ? `${selectedDate?.flexAmount} |` : '';
        const flexActionValue =  iscontinueBtn ? `Flex Continue - ${flexTaggingData?.date}` : `Flex Go Back - ${flexTaggingData?.date}`;
        trackEventAction({
            eventCategory: 'Product Page',
            eventAction: flexActionValue,
            eventLabel: `${selectedDate?.optionCode} | ${flexPrice}  ${flexTaggingData?.deliverytype} | ${flexTaggingData?.zipcode}`,
        });
    };
    return (
        <Dialog open={isOpen}>
            <div className={classes.flexWraper}>
                {flexRedesignFlag && flexImage?.url && (
                    <div className={classes.mainImage}>
                        <ResponsiveImage
                            path={flexImage?.url}
                            alt={flexImage.title}
                            className={classes.image}
                        />
                    </div>
                )}
                <div className={flexRedesignFlag ? classes.holidayRedesignBox : classes.holidayBoxBorder}>
                    <ReactMarkdown
                        className={classes.dialogTitle}
                        escapeHtml={false}
                        source={flexData[0].flexMsg?.find((message) => message.msgType === '7')?.msgText}
                    />
                </div>

                <Grid container direction="column">
                    <Grid item className={classes.flexContent}>
                        <FormControl component="fieldset" className={classes.flexOptionContainer}>
                            <RadioGroup name="flexSelect" value={selectedDate.optionCode} onChange={handleDateChange}>
                                {flexData.map((flexDay) => (
                                    <FormControlLabel
                                        value={flexDay.optionCode}
                                        className={classes.label}
                                        control={<Radio classes={{ root: flexData.length  === 1 ? classes.hideBtn : `${brandId === '1034' ? classes.floristRadioButtonColor : classes.radioButtonColor}`, checked: classes.checked }} />}
                                        label={(
                                            <ReactMarkdown
                                                className={`${flexData.length === 1 && classes.windowContentPadding} ${classes.windowContent}`}
                                                escapeHtml={false}
                                                source={flexDay.flexMsg?.find((message) => message.msgTypeLocation === 'Product')?.msgText}
                                            />
                                        )}
                                        labelPlacement="end"
                                        key={flexDay.optionCode}
                                    />
                                ))}
                            </RadioGroup>
                        </FormControl>
                        <Grid container direction="row" className={classes.buttonContainer}>
                            <Grid className={classes.MuiGridItem} item>
                                <Button className={classes.GoBackFlex} variant="outlined" onClick={() => { handleFlexClose(); trackFlexModalNavigationButton(false); }}>
                                    GO BACK
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button className={classes.ContinueFlex} variant="contained" onClick={() => { flexAddToCart(selectedDate); handleFlexClose(); trackFlexModalNavigationButton(true); }}>
                                    CONTINUE
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </Dialog>
    );
};

FlexModal.propTypes = {
    isOpen: bool.isRequired,
    handleFlexClose: func.isRequired,
    flexAddToCart: func.isRequired,
    trackEventAction: func.isRequired,
    flexData: arrayOf(
        shape({
            defaultOption: string.isRequired,
            flexAmount: string.isRequired,
            flexDate: string.isRequired,
            forcedDelDate: string.isRequired,
            optionCode: string.isRequired,
            flexMsg: arrayOf(
                shape({
                    msgText: string.isRequired,
                    msgType: string.isRequired,
                    msgTypeLocation: string.isRequired,
                }).isRequired,
            ).isRequired,
        }).isRequired,
    ).isRequired,
    featureFlags: object,
    flexTaggingData: shape({
        deliverytype: string,
        date: string,
        zipcode: string,
    }),
    dateFlexImage: shape({
        url: string,
        title: string,
    }),
    brandId: string.isRequired,
};
FlexModal.defaultProps = {
    featureFlags: {},
    flexTaggingData: {},
    dateFlexImage: {},
};
const mapStateToProps = (state) => ({
    featureFlags: getFeatureFlags(state),
});
const mapDispatchToProps = (dispatch) => ({
    trackEventAction: bindActionCreators(trackEvent, dispatch),
});
export default connect(mapStateToProps, mapDispatchToProps)(FlexModal);
